document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-copy-url]');
  if (!button) return;
  const root = button.closest('.ap-share');
  const card = button.closest('.ap-share__card');
  const input = card.querySelector('.ap-share__url');
  const status = card.querySelector('.ap-share__status');
  try {
    if (!navigator.clipboard || !window.isSecureContext) throw new Error('manual');
    await navigator.clipboard.writeText(button.dataset.copyUrl);
    status.textContent = root.dataset.copied;
  } catch {
    input.focus();
    input.select();
    input.setSelectionRange(0, input.value.length);
    status.textContent = root.dataset.failed;
  }
});
